'use strict';require('../../style/css');
require('../../list/style/css');
require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/radio/style/css.web.js
// module id = 408
// module chunks = 0